export const environment = {
  name: "prod",
  production: "production",
  apiUrl: 'https://server.labbytes.vibytes.com',
  UserPoolId: 'us-east-1_9NQ6YtOpb',
  ClientId: '5gi4tbscn7ei0c4g04asikl64m'
};


